<script>
	import { fade } from "svelte/transition";
	import { navigate } from "svelte-routing";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import DropZone from "../../components/DropZone.svelte";

	import { acceptedFileUploadList } from "../../config";
	import { pageNumber, model } from "../../stores";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let nextPageLabel = null;

	let id = "fileUploader";
	let documentList = [];
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;

	let documentUploadError = "";

	const validateDocuments = () => {
		let isValid = documentList.length > 0;
		documentUploadError = isValid ? "" : "Please upload documents";
		return isValid;
	};

	const getDocumentUploadError = () => {
		let isValid = validateDocuments();
		let docUploadErrors = isValid ? [] : [document.getElementById("docUploadError")];
		return docUploadErrors.length !== 0;
	};
</script>

<PageSection>
	<h2>Supporting Documentation</h2>
	<p>
		Please provide supporting documentation of your trading in NXL shares by using the upload box below. Supporting
		documents may include holding statements, buy and sell contract notes, CHESS statements or broker account
		statements.
	</p>
	<div class="form-row">
		<!-- <div class="form-row" transition:slide> -->
		<div class="form-group col-md-12">
			<DropZone
				{options}
				{id}
				message="Drop files here or click to upload for this registration"
				bind:documentList
			></DropZone>
		</div>
	</div>

	<div class="form-row">
		<div class="col-md-12 last">
			<NavigationButtons
				onPageValidation={getDocumentUploadError}
				{persistUrl}
				{previousPage}
				{nextPage}
				{nextPageLabel}
			></NavigationButtons>
		</div>
		{#if documentUploadError}
			<div id="docUploadError" class="error-message">
				{documentUploadError}
			</div>
		{/if}
	</div>
</PageSection>
